<template>
  <div class="mx-10">
    <!-- <pre> {{ buyers_guide_menus }}</pre> -->
    <div
      class="
        border-b border-gray-300
        text-center
        px-10
        py-4
        flex
        justify-center
        text-xl
      "
    >
      Congratulations on your purchased property! We are here to guide you
      through your journey with Moldex to having the life you deserve.
    </div>
    <div class="border-b-2 border-gray-300">
      <!-- {{buyers_guide_menus}} -->
      <v-row no-gutters>
        <v-col class="mx-2" v-for="(item, i) in buyers_guide_menus" :key="i">
          <button
            @click="selectedMenu(item)"
            class="py-12 text-white w-full bg_color_btn bg-red-900"
          >
            {{ item.title }}
          </button>
        </v-col>
      </v-row>
    </div>
    <!-- <div style="display: flex">
      <div style="flex: 1">
        <v-treeview activatable :items="items">
          <template v-slot:label="{ item }">
            <span @click="onItemClick(item)">{{ item.name }}</span>
          </template>
        </v-treeview>
      </div>
      <div style="flex: 1; background-color: lightgray">
        <span v-if="selectedItem">
          {{ selectedItem.name }}
        </span>
        <div v-html="selectedItemHtml" />
      </div>
    </div>  -->
  </div>
</template>

<script>
import { data } from "../../faq/constants/buyersGuide";
import axios from "axios";
export default {
  data() {
    return {
      buyers_guide_menus: [
        {
          name: "buyers-guide-billing-payments",
          title:"Billing Payments",
          id: 1,
        },
        {
          name: "buyers-guide-financing-scheme-payments",
          title:"Financing Scheme",
          id: 2,
        },
        {
          name: "buyers-guide-move-in",
          title:"Move-in Turnover",
          id: 3,
        },
        {
          name: "buyers-guide-title-transfer",
          title:"Title Transfer",
          id: 4,
        },
      ],
      selectedItem: null,
      selectedItemHtml: "",
      items: [
        {
          id: 1,
          name: "Applications :",
          children: [
            { id: 2, name: "Calendar : app" },
            { id: 3, name: "Chrome : app" },
            { id: 4, name: "Webstorm : app" },
          ],
        },
        {
          id: 5,
          name: "Documents :",
          children: [
            {
              id: 6,
              name: "vuetify :",
              children: [
                {
                  id: 7,
                  name: "src :",
                  children: data,
                },
              ],
            },
            {
              id: 10,
              name: "material2 :",
              children: [
                {
                  id: 11,
                  name: "src :",
                  children: [
                    { id: 12, name: "v-btn : ts" },
                    { id: 13, name: "v-card : ts" },
                    { id: 14, name: "v-window : ts" },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: 15,
          name: "Downloads :",
          children: [
            { id: 16, name: "October : pdf" },
            { id: 17, name: "November : pdf" },
            { id: 18, name: "Tutorial : html" },
          ],
        },
        {
          id: 19,
          name: "Videos :",
          children: [
            {
              id: 20,
              name: "Tutorials :",
              children: [
                { id: 21, name: "Basic layouts : mp4" },
                { id: 22, name: "Advanced techniques : mp4" },
                { id: 23, name: "All about app : dir" },
              ],
            },
            { id: 24, name: "Intro : mov" },
            { id: 25, name: "Conference introduction : avi" },
          ],
        },
      ],
    };
  },
 
  methods: {
    onItemClick(item) {
      this.selectedItem = item;
      if (item.html) {
        axios.get(`${window.location.origin}/html/${item.html}`).then((res) => {
          this.selectedItemHtml = res.data;
        });
      }
    },
    getItems(e) {
      return {
        buyers_guide_menu_id: e.buyers_guide_menu_id,
        name: e.item,
        parent_id: e.parent_id,
      };
    },
    // get_menus() {
    //   axios.get("/buyers_guide/menus").then((res) => {
    //     this.buyers_guide_menus = res.data.map(this.getItems);
    //   });
    // },
    selectedMenu(i) {
      this.$router.push({
        name: i.name,
        params: {
          info: i,
        },
      });
    },
  },
};
</script><style scoped>
.bg_color_btn {
  background: #033a87;
  background-image: linear-gradient(-10deg, #0047ab);
}
.bg_color_btn:hover {
  background: rgb(152, 4, 4);
}
</style>